import { BID_SECTION_LABELS, getBidSection } from "@/lib/bid-sections"

// Page titles for the top-bar breadcrumb. Standalone module so tests can
// import the map without pulling AppLayout's heavy dependency graph (pdfjs).
export const pageTitles: Record<string, string> = {
  "/app": "Home",
  "/app/my-work": "Needs you",
  "/app/bids": "Bids",
  "/app/knowledge": "Knowledge",
  "/app/knowledge/library": "Library",
  "/app/knowledge/company-profile": "Company profile",
  "/app/knowledge/templates": "Templates",
  "/app/knowledge/prompts": "Saved prompts",
  "/app/assistant": "Assistant",
  "/app/settings": "Settings",
  "/app/settings/users": "Settings",
  "/app/settings/export-templates": "Settings",
  "/app/settings/integrations": "Settings",
  "/app/help": "Help",
  "/app/admin": "Admin",
  "/app/admin/demo-requests": "Demo Requests",
  "/app/admin/organizations": "Organisations",
  "/app/admin/users": "Users",
  "/app/admin/usage": "Usage",
}

export function getPageTitle(pathname: string): string {
  if (pageTitles[pathname]) return pageTitles[pathname]
  if (pathname.startsWith("/app/help/")) return "Help"
  if (pathname.startsWith("/app/assistant/")) return "Assistant"
  return "BidContext"
}

/**
 * Breadcrumb label for a bid page's section (R4 bid menu names), or null on
 * the bid's Overview, which the bid title crumb already stands for.
 */
export function getBidSectionTitle(pathname: string): string | null {
  if (!/^\/app\/bids\/[^/]+\/.+/.test(pathname)) return null
  const section = getBidSection(pathname)
  return section === "overview" ? null : BID_SECTION_LABELS[section]
}
